// extracted by mini-css-extract-plugin
export default {"sidebarHeading":"Sidebar_sidebarHeading__mWLiA","sidebarDesc":"Sidebar_sidebarDesc__93sWD","customSidebar":"Sidebar_customSidebar__fF2G7"};